module.exports = __webpack_public_path__ + "static/media/asset301.ff338247.jpg";